export const formatDateTime = (apiDateTime) => {
    if (!apiDateTime) return '';
    
    try {
        const date = new Date(apiDateTime);
        
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        
        return `${hours}:${minutes} ${day}.${month}.${year}`;
    } catch (error) {
        console.error('Date formatting error:', error);
        return 'Неверный формат даты';
    }
};

export const checkDeviceLink = (paramLastDate, browserTime, thresholdMinutes = 5) => {
    if (!paramLastDate || !browserTime) return false;
    
    try {
      const serverTime = new Date(paramLastDate);
      const diffMinutes = Math.floor(Math.abs(browserTime - serverTime) / (1000 * 60));
      return diffMinutes <= thresholdMinutes;
    } catch (e) {
      return false;
    }
  };

